import { QuestionService } from './../question.service';
import { Component, OnInit , Inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { papers , topics} from '../static'
import {MatDialog , MAT_DIALOG_DATA} from '@angular/material/dialog';
@Component({
  selector: 'app-sq-paper',
  templateUrl: './sq-paper.component.html',
  styleUrls: ['./sq-paper.component.css']
})
export class SqPaperComponent implements OnInit {

  papers = papers;
  topics = topics;
  paper;
  exam;
  questions;
  type;
  title;
  paperId;
  lang = 'E';
  constructor(
    private route: ActivatedRoute,
    private QuestionService: QuestionService,
    public dialog: MatDialog
  ) { }

  ngOnInit() {
    this.route.paramMap.subscribe(params => {

      Object.assign(this, {
        type : params.get('type'),
        paperId : params.get('paperId'),
        exam : params.get('exam'),
      })
      
      if (this.type == 'year'){
        this.title = this.papers.find(x => x.id == params.get('paperId')).name;
      } else if(this.type == 'topic'){
        this.title = this.topics.find(x => x.tag == params.get('paperId')).name;
      }
      this.questions = this.QuestionService.getSQByTopic(this.type,this.paperId,this.exam);
    });    
    
   
  }
  setLang(lang){
    this.lang = lang;    
  }

  openDialog() {
   this.dialog.open(DialogContentExampleDialog);  
  }

  openAnswerDialog(question,lang) {
    console.log({question, lang});

    this.dialog.open(SQAnswerDialog,{
      data: { question: question , lang:lang },
    });
     
   }
}

@Component({
  selector: 'dialog-content-example-dialog',
  templateUrl: './dialog-content-example-dialog.html',
})
export class DialogContentExampleDialog {}


@Component({
  selector: 'sq-answer-dialog',
  templateUrl: './sq-answer-dialog.html',
})

export class SQAnswerDialog {
  constructor(@Inject(MAT_DIALOG_DATA) public data) {}

  
}